import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from '../../../ui/core';
import { useFormatters } from '../../../hooks';
import { useDispatch } from 'react-redux';
import { addCredits, refundRide } from '../../../redux/Users/actions';
import useToast from '../../../hooks/useToast';

const EXPERIENCE_DATA = [
  {
    severity: '1 - Minor',
    experience: '0-30 minutes',
    immediateEscalation: 'No',
    creditPercentage: 0,
    minimumRefund: 0,
    fullRefund: false,
    agentScript: 'I\'m sorry for the short delay today — while it doesn\'t qualify for a credit, we appreciate your patience and are always working to keep pick-ups on time.',
    combinedOption: 'Delay: 1 - Minor - 0-30 minutes',
    type: 'delay',
    minDelay: 0,
    maxDelay: 30,
    reasonId: 'DELAY'
  },
  {
    severity: '2 - Moderate',
    experience: '31-60 minutes',
    immediateEscalation: 'No',
    creditPercentage: 10,
    minimumRefund: 5,
    fullRefund: false,
    agentScript: 'We apologize for the delay — I\'ve added {amount} in credits to your account.',
    combinedOption: 'Delay: 2 - Moderate - 31-60 minutes',
    type: 'delay',
    minDelay: 31,
    maxDelay: 60,
    reasonId: 'DELAY'
  },
  {
    severity: '3 - Serious',
    experience: '61-90 minutes',
    immediateEscalation: 'No',
    creditPercentage: 20,
    minimumRefund: 10,
    fullRefund: false,
    agentScript: 'We apologize for the delay — I\'ve added {amount} in credits to your account.',
    combinedOption: 'Delay: 3 - Serious - 61-90 minutes',
    type: 'delay',
    minDelay: 61,
    maxDelay: 90,
    reasonId: 'DELAY'
  },
  {
    severity: '4 - Critical',
    experience: '91-120 minutes',
    immediateEscalation: 'No',
    creditPercentage: 30,
    minimumRefund: 15,
    fullRefund: false,
    agentScript: 'We apologize for the delay — I\'ve added {amount} in credits to your account.',
    combinedOption: 'Delay: 4 - Critical - 91-120 minutes',
    type: 'delay',
    minDelay: 91,
    maxDelay: 120,
    reasonId: 'DELAY'
  },
  {
    severity: '4 - Critical',
    experience: '121-150 minutes',
    immediateEscalation: 'No',
    creditPercentage: 30,
    minimumRefund: 20,
    fullRefund: false,
    agentScript: 'We apologize for the delay — I\'ve added {amount} in credits to your account.',
    combinedOption: 'Delay: 4 - Critical - 121-150 minutes',
    type: 'delay',
    minDelay: 121,
    maxDelay: 150,
    reasonId: 'DELAY'
  },
  {
    severity: '4 - Critical',
    experience: '151-180 minutes',
    immediateEscalation: 'No',
    creditPercentage: 50,
    minimumRefund: 25,
    fullRefund: false,
    agentScript: 'We apologize for the delay — I\'ve added {amount} in credits to your account.',
    combinedOption: 'Delay: 4 - Critical - 151-180 minutes',
    type: 'delay',
    minDelay: 151,
    maxDelay: 180,
    reasonId: 'DELAY'
  },
  {
    severity: '4 - Critical',
    experience: '180+ minutes',
    immediateEscalation: 'No',
    creditPercentage: 50,
    minimumRefund: 30,
    fullRefund: false,
    agentScript: 'We apologize for the delay — I\'ve added {amount} in credits to your account.',
    combinedOption: 'Delay: 4 - Critical - 180+ minutes',
    type: 'delay',
    minDelay: 181,
    maxDelay: Infinity,
    reasonId: 'DELAY'
  },
  {
    severity: '4 - Critical',
    experience: 'Cancellation',
    immediateEscalation: 'No',
    creditPercentage: 100,
    minimumRefund: 0,
    fullRefund: false,
    agentScript: 'We apologize for the delay — a full credit refund of {amount} has been issued to your account.',
    combinedOption: 'Delay: 4 - Critical - Delay led to cancellation',
    type: 'delay',
    minDelay: Infinity,
    maxDelay: Infinity,
    reasonId: 'DELAY'
  },
  {
    severity: '1 - Minor',
    experience: 'Mild Odor',
    immediateEscalation: 'No',
    creditPercentage: 10,
    fullRefund: false,
    agentScript: 'Sorry for the inconvenience—I\'ve added a small Hitch credit to your account.',
    combinedOption: '1 - Minor - Mild Odor',
    reasonId: 'VEHICLE_ISSUE'
  },
  {
    severity: '1 - Minor',
    experience: 'Temperature Slightly Off',
    immediateEscalation: 'No',
    creditPercentage: 10,
    fullRefund: false,
    agentScript: 'Sorry for the inconvenience—I\'ve added a small Hitch credit to your account.',
    combinedOption: '1 - Minor - Temperature Slightly Off',
    reasonId: 'VEHICLE_ISSUE'
  },
  {
    severity: '1 - Minor',
    experience: 'Small Route Inefficiency',
    immediateEscalation: 'No',
    creditPercentage: 10,
    fullRefund: false,
    agentScript: 'Sorry for the inconvenience—I\'ve added a small Hitch credit to your account.',
    combinedOption: '1 - Minor - Small Route Inefficiency',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '1 - Minor',
    experience: 'Unprofessional Remark (Non-offensive)',
    immediateEscalation: 'No',
    creditPercentage: 10,
    fullRefund: false,
    agentScript: 'Sorry for the inconvenience—I\'ve added a small Hitch credit to your account.',
    combinedOption: '1 - Minor - Unprofessional Remark (Non-offensive)',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '2 - Moderate',
    experience: 'Noticeably Dirty Interior',
    immediateEscalation: 'No',
    creditPercentage: 20,
    fullRefund: false,
    agentScript: 'I\'ve added a credit to your account for the discomfort you experienced.',
    combinedOption: '2 - Moderate - Noticeably Dirty Interior',
    reasonId: 'VEHICLE_ISSUE'
  },
  {
    severity: '2 - Moderate',
    experience: 'Persistent Unwanted Chat',
    immediateEscalation: 'No',
    creditPercentage: 20,
    fullRefund: false,
    agentScript: 'I\'ve added a credit to your account for the discomfort you experienced.',
    combinedOption: '2 - Moderate - Persistent Unwanted Chat',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '2 - Moderate',
    experience: 'Loud Music (After Request)',
    immediateEscalation: 'No',
    creditPercentage: 20,
    fullRefund: false,
    agentScript: 'I\'ve added a credit to your account for the discomfort you experienced.',
    combinedOption: '2 - Moderate - Loud Music (After Request)',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '2 - Moderate',
    experience: 'Broken Comfort Feature (AC/Seat)',
    immediateEscalation: 'No',
    creditPercentage: 20,
    fullRefund: false,
    agentScript: 'I\'ve added a credit to your account for the discomfort you experienced.',
    combinedOption: '2 - Moderate - Broken Comfort Feature (AC/Seat)',
    reasonId: 'VEHICLE_ISSUE'
  },
  {
    severity: '3 - Serious',
    experience: 'Reckless Driving',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'Your safety matters. I\'ve issued a full refund for this ride and escalated the incident.',
    combinedOption: '3 - Serious - Reckless Driving',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '3 - Serious',
    experience: 'Offensive/Discriminatory Language',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'Your safety matters. I\'ve issued a full refund for this ride and escalated the incident.',
    combinedOption: '3 - Serious - Offensive/Discriminatory Language',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '3 - Serious',
    experience: 'Suspected Impairment',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'Your safety matters. I\'ve issued a full refund for this ride and escalated the incident.',
    combinedOption: '3 - Serious - Suspected Impairment',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '3 - Serious',
    experience: 'Unsafe Vehicle Condition',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'Your safety matters. I\'ve issued a full refund for this ride and escalated the incident.',
    combinedOption: '3 - Serious - Unsafe Vehicle Condition',
    reasonId: 'VEHICLE_ISSUE'
  },
  {
    severity: '4 - Critical',
    experience: 'Physical Altercation',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'We\'ve issued a full refund and escalated to our safety team immediately.',
    combinedOption: '4 - Critical - Physical Altercation',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '4 - Critical',
    experience: 'Unauthorized Detour',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'We\'ve issued a full refund and escalated to our safety team immediately.',
    combinedOption: '4 - Critical - Unauthorized Detour',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '4 - Critical',
    experience: 'Confirmed Impairment',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'We\'ve issued a full refund and escalated to our safety team immediately.',
    combinedOption: '4 - Critical - Confirmed Impairment',
    reasonId: 'DRIVER_ISSUE'
  },
  {
    severity: '4 - Critical',
    experience: 'Passenger Abandoned',
    immediateEscalation: 'Yes',
    creditPercentage: null,
    fullRefund: true,
    agentScript: 'We\'ve issued a full refund and escalated to our safety team immediately.',
    combinedOption: '4 - Critical - Passenger Abandoned',
    reasonId: 'DRIVER_ISSUE'
  }
];

const MakeItRightDialog = ({ open, onClose, ride, trip, fullTripData }) => {
  const toast = useToast();
  const [selectedExperience, setSelectedExperience] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const dispatch = useDispatch();
  const f = useFormatters();
  
  const fullTripRide = fullTripData?.rides?.find(fullRide => fullRide._id === ride.id || fullRide._id === ride.rideId) ||
                      fullTripData?.cancelledRides?.find(fullRide => fullRide._id === ride.id || fullRide._id === ride.rideId);
  
  // Use the enriched ride data from fullTripData
  const enrichedRide = fullTripRide;
  
  React.useEffect(() => {
    if (open && !selectedExperience) {
      const getDefaultDelayOption = () => {
        if (!enrichedRide?.pickupInfo?.driverArrivalStatus?.minutesLate) {
          return '';
        }
        
        const minutesLate = enrichedRide.pickupInfo.driverArrivalStatus.minutesLate;
        
        const delayOption = EXPERIENCE_DATA.find(option => 
          option.type === 'delay' && 
          minutesLate >= option.minDelay && 
          minutesLate <= option.maxDelay
        );
        
        return delayOption ? delayOption.combinedOption : '';
      };
      
      const defaultDelay = getDefaultDelayOption();
      if (defaultDelay) {
        setSelectedExperience(defaultDelay);
      }
    }
  }, [open, enrichedRide, selectedExperience]);
  
  const handleSubmit = async () => {
    const experience = EXPERIENCE_DATA.find((e) => e.combinedOption === selectedExperience);
    if (!experience) return;

    try {
      setIsSubmitting(true);
      const totalPrice = enrichedRide.totalPrice;
      const calculatedCreditAmount = Number(((totalPrice * experience.creditPercentage) / 100).toFixed(2));
      const creditAmount = Math.max(calculatedCreditAmount, experience.minimumRefund || 0);
      let result;

      if (experience.fullRefund) {
        result = await refundRide({
          userId: ride.rider.id,
          rideId: ride.id,
          amount: totalPrice,
          reasonId: experience.reasonId,
          reasonDescription: experience.combinedOption,
        })(dispatch);
      } else {
        result = await addCredits({
          userId: ride.rider.id,
          reason: experience.reasonId,
          description: experience.combinedOption,
          items: [
            {
              type: 'GENERAL',
              key: 'generalCredits',
              value: creditAmount,
            },
          ],
          rideId: ride.id || null,
        })(dispatch);
      }
      
      if (result?.success) {
        setSuccessData({
          experience,
          creditAmount,
          totalPrice,
        });
      } else {
        throw result.error
      }

      setSelectedExperience('');
      onClose();
    } catch (err) {
      setSuccessData(null);
      toast.error(`Error: ${err.message}`)
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const handleClose = () => {
    setSelectedExperience('');
    setSuccessData(null);
    setShowConfirmation(false);
    onClose();
  };

  const handleConfirmSubmit = () => {
    setShowConfirmation(false);
    handleSubmit();
  };
  
  const selectedExperienceData = EXPERIENCE_DATA.find(item => item.combinedOption === selectedExperience);
  
  // Calculate credit amount for button visibility
  const getCreditAmount = () => {
    if (!selectedExperienceData || !enrichedRide?.totalPrice) return 0;
    if (selectedExperienceData.fullRefund) return enrichedRide.totalPrice;
    
    const calculatedAmount = (enrichedRide.totalPrice * selectedExperienceData.creditPercentage) / 100;
    return Math.max(calculatedAmount, selectedExperienceData.minimumRefund || 0);
  };
  
  const creditAmount = getCreditAmount();
  const shouldShowSubmitButton = selectedExperienceData && (selectedExperienceData.fullRefund || creditAmount > 0);
  
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h6" component="span">Make it right</Typography>
        <Chip 
          label="BETA" 
          color="warning" 
          size="small" 
          sx={{ ml: 1, fontSize: '0.75rem', height: '20px' }}
        />
      </DialogTitle>
      <DialogContent>
        {!successData && !showConfirmation && (
          <Stack spacing={3} sx={{ mt: 1 }}>
            <Box>
              <Stack direction="row" spacing={6}>
                <Box>
                  <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                    Rider
                  </Typography>
                  <Typography variant="body1">
                    {ride?.rider?.firstName} {ride?.rider?.lastName}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                    Departure
                  </Typography>
                  <Typography variant="body1">
                    {fullTripRide?.departureTime && f.date.toTimezoneLocaleString(
                      fullTripRide.departureTime,
                      trip.originCity.timeZone,
                      'M/DD h:mm A z',
                    )}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                    Price
                  </Typography>
                  <Typography variant="body1">
                    {enrichedRide?.totalPrice ? (
                      <>
                        {f.number.currency(enrichedRide.totalPrice)}
                        {enrichedRide.totalCreditsUsed > 0 && (
                          <span style={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                            {' '}({f.number.currency(enrichedRide.totalPrice - enrichedRide.totalCreditsUsed)} cash + {f.number.currency(enrichedRide.totalCreditsUsed)} credits)
                          </span>
                        )}
                      </>
                    ) : '-'}
                  </Typography>
                </Box>
              </Stack>
            </Box>

            {/* Trip Performance Details */}
            {enrichedRide && ride.status !== 'cancelled' && (
              <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Trip Performance Details
                </Typography>
                <Stack direction="row" spacing={3}>
                  {/* Pickup Timeliness */}
                  {enrichedRide.pickupInfo && (
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        Pickup Timeliness
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                        {enrichedRide.pickupInfo.onTimeStatus && (
                          <Chip 
                            label={enrichedRide.pickupInfo.onTimeStatus.label}
                            color={enrichedRide.pickupInfo.onTimeStatus.color === 'success.main' ? 'success' : 
                                   enrichedRide.pickupInfo.onTimeStatus.color === 'warning.main' ? 'warning' : 'error'}
                            size="small"
                          />
                        )}
                        {enrichedRide.pickupInfo.driverArrivalStatus && (
                          <Chip 
                            label={enrichedRide.pickupInfo.driverArrivalStatus.label}
                            color={enrichedRide.pickupInfo.driverArrivalStatus.color === 'success.main' ? 'success' : 
                                   enrichedRide.pickupInfo.driverArrivalStatus.color === 'warning.main' ? 'warning' : 
                                   enrichedRide.pickupInfo.driverArrivalStatus.color === 'error.main' ? 'error' : 'default'}
                            size="small"
                          />
                        )}
                      </Stack>
                      {enrichedRide.pickupInfo.onTimeStatus && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                          Scheduled: {f.date.toTimezoneLocaleString(
                            enrichedRide.pickupInfo.onTimeStatus.scheduledTime,
                            trip.originCity.timeZone,
                            f.date.DateFormats.TIME_SIMPLE_WITH_TIMEZONE,
                          )}
                        </Typography>
                      )}
                      {enrichedRide.pickupInfo.action && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                          Actual: {f.date.toTimezoneLocaleString(
                            enrichedRide.pickupInfo.action.timestamp,
                            trip.originCity.timeZone,
                            f.date.DateFormats.TIME_SIMPLE_WITH_TIMEZONE,
                          )}
                        </Typography>
                      )}
                    </Box>
                  )}

                  {/* Dropoff Timeliness */}
                  {enrichedRide.dropoffInfo && (
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        Dropoff Timeliness
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                        {enrichedRide.dropoffInfo.onTimeStatus && (
                          <Chip 
                            label={enrichedRide.dropoffInfo.onTimeStatus.label}
                            color={enrichedRide.dropoffInfo.onTimeStatus.color === 'success.main' ? 'success' : 
                                   enrichedRide.dropoffInfo.onTimeStatus.color === 'warning.main' ? 'warning' : 'error'}
                            size="small"
                          />
                        )}
                      </Stack>
                      {enrichedRide.dropoffInfo.onTimeStatus && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                          Scheduled: {f.date.toTimezoneLocaleString(
                            enrichedRide.dropoffInfo.onTimeStatus.scheduledTime,
                            trip.originCity.timeZone,
                            f.date.DateFormats.TIME_SIMPLE_WITH_TIMEZONE,
                          )}
                        </Typography>
                      )}
                      {enrichedRide.dropoffInfo.action && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                          Actual: {f.date.toTimezoneLocaleString(
                            enrichedRide.dropoffInfo.action.timestamp,
                            trip.originCity.timeZone,
                            f.date.DateFormats.TIME_SIMPLE_WITH_TIMEZONE,
                          )}
                        </Typography>
                      )}
                    </Box>
                  )}

                  {/* Dropoff Location */}
                  {enrichedRide.dropoffInfo?.locationInfo && (
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        Dropoff Location
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                        <Chip 
                          label={`${enrichedRide.dropoffInfo.locationInfo.distance} mi away`}
                          color={enrichedRide.dropoffInfo.locationInfo.color === 'success.main' ? 'success' : 
                                 enrichedRide.dropoffInfo.locationInfo.color === 'warning.main' ? 'warning' : 'error'}
                          size="small"
                        />
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                          at {enrichedRide.dropoffInfo.locationInfo.locationTime}
                        </Typography>
                      </Stack>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                        Scheduled: {fullTripRide?.dropOff?.name || fullTripRide?.dropOff?.address || 'Unknown'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                        Actual: {enrichedRide.dropoffInfo.locationInfo.actualLocation.lat.toFixed(6)}, {enrichedRide.dropoffInfo.locationInfo.actualLocation.lon.toFixed(6)}
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </Box>
            )}

            <FormControl fullWidth>
              <InputLabel sx={{ backgroundColor: 'background.paper', px: 0.5 }}>Experience</InputLabel>
              <Select
                value={selectedExperience}
                label="Experience"
                onChange={(e) => setSelectedExperience(e.target.value)}
              >
                {EXPERIENCE_DATA.map((item) => (
                  <MenuItem key={item.combinedOption} value={item.combinedOption}>
                    {item.combinedOption}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {selectedExperienceData && (
              <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Resolution Details
                </Typography>
                <Stack spacing={2}>
                  <Stack direction="row" spacing={2}>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Severity
                      </Typography>
                      <Chip 
                        label={selectedExperienceData.severity} 
                        color={selectedExperienceData.severity.includes('1') ? 'success' : 
                               selectedExperienceData.severity.includes('2') ? 'warning' :
                               selectedExperienceData.severity.includes('3') ? 'error' : 'error'}
                        size="small"
                      />
                    </Box>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Immediate Escalation
                      </Typography>
                      <Chip 
                        label={selectedExperienceData.immediateEscalation} 
                        color={selectedExperienceData.immediateEscalation === 'Yes' ? 'error' : 'default'}
                        size="small"
                      />
                    </Box>
                  </Stack>
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      {selectedExperienceData.fullRefund ? 'Full Refund' : 'Issue Credits'}
                    </Typography>
                    <Typography variant="body1">
                      {selectedExperienceData.fullRefund ? (
                        enrichedRide?.totalPrice ? (
                          <>
                            {f.number.currency(enrichedRide.totalPrice)}
                            {enrichedRide.totalCreditsUsed > 0 && (
                              <span style={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                                {' '}({f.number.currency(enrichedRide.totalPrice - enrichedRide.totalCreditsUsed)} cash + {f.number.currency(enrichedRide.totalCreditsUsed)} credits)
                              </span>
                            )}
                          </>
                        ) : '-'
                      ) : (
                        enrichedRide?.totalPrice ? (
                          <>
                            {(() => {
                              const calculatedAmount = (enrichedRide.totalPrice * selectedExperienceData.creditPercentage) / 100;
                              const finalAmount = Math.max(calculatedAmount, selectedExperienceData.minimumRefund || 0);
                              return f.number.currency(finalAmount);
                            })()}
                            {' '}({selectedExperienceData.creditPercentage}% of total, minimum ${selectedExperienceData.minimumRefund || 0})
                          </>
                        ) : '-'
                      )}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      Agent Script
                    </Typography>
                    <Typography variant="body2" sx={{ fontStyle: 'italic', p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
                      "{(() => {
                        if (selectedExperienceData.type === 'delay' && enrichedRide?.totalPrice) {
                          const calculatedAmount = (enrichedRide.totalPrice * selectedExperienceData.creditPercentage) / 100;
                          const finalAmount = Math.max(calculatedAmount, selectedExperienceData.minimumRefund || 0);
                          return selectedExperienceData.agentScript.replace('{amount}', f.number.currency(finalAmount));
                        }
                        return selectedExperienceData.agentScript;
                      })()}"
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            )}
          </Stack>
        )}

        {showConfirmation && (
          <Box sx={{ mt: 1 }}>
            <Typography variant="h6" gutterBottom color="warning.main">
              Confirm Resolution
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Are you sure you want to issue this resolution to {ride?.rider?.firstName} {ride?.rider?.lastName}?
            </Typography>
            
            <Box sx={{ p: 2, border: '1px solid', borderColor: 'warning.main', borderRadius: 1, bgcolor: 'warning.50' }}>
              <Typography variant="subtitle2" gutterBottom>
                Resolution Summary
              </Typography>
              <Stack spacing={2}>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    Experience
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                    {selectedExperience}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    Resolution Type
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                    {selectedExperienceData?.fullRefund ? 'Full Refund' : 'Credits'}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    Amount
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                    {selectedExperienceData?.fullRefund ? (
                      enrichedRide?.totalPrice ? (
                        <>
                          {f.number.currency(enrichedRide.totalPrice)}
                          {enrichedRide.totalCreditsUsed > 0 && (
                            <span style={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                              {' '}({f.number.currency(enrichedRide.totalPrice - enrichedRide.totalCreditsUsed)} cash + {f.number.currency(enrichedRide.totalCreditsUsed)} credits)
                            </span>
                          )}
                        </>
                      ) : '-'
                    ) : (
                      enrichedRide?.totalPrice ? (
                        <>
                          {(() => {
                            const calculatedAmount = (enrichedRide.totalPrice * selectedExperienceData.creditPercentage) / 100;
                            const finalAmount = Math.max(calculatedAmount, selectedExperienceData.minimumRefund || 0);
                            return f.number.currency(finalAmount);
                          })()}
                          {' '}({selectedExperienceData.creditPercentage}% of total, minimum ${selectedExperienceData.minimumRefund || 0})
                        </>
                      ) : '-'
                    )}
                  </Typography>
                </Box>
                {selectedExperienceData?.immediateEscalation === 'Yes' && (
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Escalation
                    </Typography>
                    <Chip 
                      label="Will be escalated immediately" 
                      color="error"
                      size="small"
                    />
                  </Box>
                )}
                <Box>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    Agent Script
                  </Typography>
                  <Typography variant="body2" sx={{ fontStyle: 'italic', p: 1, bgcolor: 'background.paper', borderRadius: 1 }}>
                    "{(() => {
                      if (selectedExperienceData.type === 'delay' && enrichedRide?.totalPrice) {
                        const calculatedAmount = (enrichedRide.totalPrice * selectedExperienceData.creditPercentage) / 100;
                        const finalAmount = Math.max(calculatedAmount, selectedExperienceData.minimumRefund || 0);
                        return selectedExperienceData.agentScript.replace('{amount}', f.number.currency(finalAmount));
                      }
                      return selectedExperienceData.agentScript;
                    })()}"
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Box>
        )}

        {successData && (
          <Box sx={{ mt: 1 }}>
            <Typography variant="h6" gutterBottom>
              Resolution issued
            </Typography>
            <Stack spacing={2}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Rider
                </Typography>
                <Typography variant="body1">
                  {ride?.rider?.firstName} {ride?.rider?.lastName}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Credits issued
                </Typography>
                <Typography variant="body1">
                  {f.number.currency(successData.creditAmount)} ({selectedExperience})
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Agent Script
                </Typography>
                <Typography variant="body2" sx={{ fontStyle: 'italic', p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
                  "{successData.experience.agentScript}"
                </Typography>
              </Box>
            </Stack>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {successData ? 'Done' : showConfirmation ? 'Cancel' : 'Cancel'}
        </Button>
        {!successData && !showConfirmation && (
          <Button 
            onClick={() => setShowConfirmation(true)} 
            variant="contained" 
            color="primary"
            disabled={!selectedExperience || isSubmitting}
            sx={{ display: shouldShowSubmitButton ? 'inline-flex' : 'none' }}
          >
            {selectedExperienceData?.fullRefund ? 'Issue full refund' : 
             selectedExperienceData ? 'Issue credits' : 'Submit'}
          </Button>
        )}
        {showConfirmation && (
          <Button 
            onClick={handleConfirmSubmit} 
            variant="contained" 
            color="primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting…' : 'Confirm Resolution'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MakeItRightDialog; 